import { importProvidersFrom } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { DynamicTranslateLoaderService } from '../services/dynamic-translate-loader.service';

export function provideTranslation() {
  return importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: DynamicTranslateLoaderService,
        deps: [HttpClient]
      }
    })
  );
}
